import React, { SVGProps } from 'react';

const Checkmark: React.FC<SVGProps<SVGSVGElement>> = (props) => (
    <svg
        xmlns='http://www.w3.org/2000/svg'
        fill='none'
        viewBox='0 0 16 16'
        width={16}
        height={16}
        {...props}
    >
        <path
            stroke='currentColor'
            strokeLinecap='round'
            strokeLinejoin='round'
            strokeWidth={1.5}
            d='m2.81 8.653 3.144 3.085 7.236-7.476'
        />
    </svg>
);

export default Checkmark;
